// extracted by mini-css-extract-plugin
export default {"error":"styles_error__yOs2V","errorBorder":"styles_errorBorder__QZFK7"};